
import {  getOssData,getExtendInfoData,findImportInfo,getExcelOssData,
checkUploader, documentResourceSign, splitUploadSign, splitUploadComplete, getResourceCategoryList } from "./upload.api";

import CommonTree from '../../components/models/commonTree'

export default class UploadService {
    // getOrganizationPersonList=async ({organizationId,selectType,organizationType}):Promise<PersonItem[]>  => {
    //     let { data } = await getOrganizationPersonList({organizationId,selectType,organizationType});
    //     // let personItemList= data.map(personItem=>new PersonItem(personItem))
    //     return personItemList
    // }
    getOssData=async (uploadSignURL) => {
        let { data } = await getOssData(uploadSignURL);
        // let personItemList= data.map(personItem=>new PersonItem(personItem))
        return data
    }
    getExcelOssData=async (uploadSignURL) => {
        let { data } = await getExcelOssData(uploadSignURL);
        // let personItemList= data.map(personItem=>new PersonItem(personItem))
        return data
    }
    getExtendInfoData=async (ossImgUrl) => {
        let data = await getExtendInfoData(ossImgUrl);
        // let personItemList= data.map(personItem=>new PersonItem(personItem))
        return data
    }
    findImportInfo=async({templateSn,bizParam},url)=>{
        let { data } = await findImportInfo({templateSn,bizParam},url);
        return data
    }
    // 获取组件的上传类型（阿里云/天翼云）
    checkUploader=async({url,type})=>{
        let { data } = await checkUploader({url,type});
        return data
    }
    // 资源文件整体上传签名（阿里云/天翼云的文档上传）
    normalResourceSign=async({url,typeEnum})=>{
        let { data } = await documentResourceSign({url,typeEnum});
        return data
    }
    // 天翼云音视频分片上传获取签名
    splitUploadSign=async({url = '', typeEnum, partSize})=>{
        let { data } = await splitUploadSign({url, typeEnum, partSize});
        return data
    }
    // 分片上传全部结束后，调取此接口，⾳视频，分⽚上传完成通知
    splitUploadComplete=async({url, ossTypeEnum, fileKey, uploadId, etags})=>{
        let { data } = await splitUploadComplete({url, ossTypeEnum, fileKey, uploadId, etags});
        return data
    }
    // 获取资源列表
    getResourceCategoryList=async(url)=>{
        let { data } = await getResourceCategoryList(url);
        let list = data && data.length && data.map(item => new CommonTree(item))
        return list
    }
}